import { Box, Container, Grid, useTheme } from "@mui/material";
import { HorizontalScrollList } from "../horizontal-scroll-list/index.js";
import { SingleProduct } from "./single-product.js";
import { useMediaQuery } from "../utilities/index.js";
import React from "react";
export const ProductGrid = ({ products = [] }) => {
    const theme = useTheme();
    const isAtLeastSm = useMediaQuery(theme.breakpoints.up("sm"));
    if (products.length === 0)
        return null;
    return isAtLeastSm ? (React.createElement(Container, { maxWidth: "xl" },
        React.createElement(Grid, { component: "ul", container: true, spacing: { xs: 4, md: 6, lg: 10 }, sx: { px: 0, listStyleType: "none" } }, products.map((product) => (React.createElement(Grid, { component: "li", item: true, key: `product-grid-${product.slug}`, sm: 3 },
            React.createElement(SingleProduct, { product: product }))))))) : (React.createElement(HorizontalScrollList, { items: 2.35 }, products.map((product) => (React.createElement(Box, { component: "li", key: `product-scroll-${product.slug}` },
        React.createElement(SingleProduct, { product: product }))))));
};
//# sourceMappingURL=product-grid.js.map